import {customAxiosBE} from "../config";

export async function deletePeriodDateAPI(id) {
    return customAxiosBE.delete(`/periodDate/${id}`);
}
